import PropTypes from 'prop-types'

import { useEffect, useState } from 'react'

import { ConfigProvider, Table } from 'antd'
import '@/assets/style/dynamicTable.scss'

/**
 * Dynamic table  { column are fetch from the api }
 * @param {*} param0
 * @param {Object} param0.unFormattedColumns
 * @param {Array} param0.dataSource
 * @param {Boolean} param0.loading
 * @returns
 */

const DynamicTable = ({ dataSource, loading }) => {
  const [columns, setColumns] = useState([])

  useEffect(() => {
    ;(async function () {
      const unFormattedColumn = (await dataSource)
        ? Object.keys(dataSource[0])
        : {}

      setColumns(
        unFormattedColumn?.map((column) => {
          return {
            title: column,
            dataIndex: column,
            key: column,
            align: 'center',
            render: (text) => <div style={{ lineHeight: '20px' }}>{text}</div>,
          }
        }),
      )
    })()
  }, [dataSource])

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              rowHoverBg: '#00b96b',
              borderColor: '#00b96b',
            },
          },
        }}
      >
        <Table
          size="large"
          columns={columns}
          dataSource={loading ? [] : dataSource}
          bordered
          loading={loading}
          scroll={{ x: true, y: true }}
        />
      </ConfigProvider>
    </>
  )
}

DynamicTable.propTypes = {
  // columns: PropTypes.arrayOf(PropTypes.object),
  dataSource: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
}

DynamicTable.defaultProps = {
  dataSource: [],
  loading: false,
}
export default DynamicTable
